import { graphql } from "gql.tada";
import { LinkFragment } from "./LinkFragment";

export const ListItemFragment = graphql(
  `
    fragment ListItemFragment on ListItem {
      _id
      eyebrow
      title
      subtitle
      ctaText
      externalUrl
      ctaLink {
        ...LinkFragment
      }
      logo { url }
      videoPosterImage { url }
      video { url }
      media { url contentType }
    }
  `,
  [LinkFragment]
);
